// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Blockly from "blockly";
import BlocklyJs from "blockly/javascript";
import { appendProcedureCallFields } from "common/blockly/fields";

export const InitProceduresCallBlock = () => {
  Blockly.Blocks["procedures_callnoreturn_1"] = {
    init: function () {
      appendProcedureCallFields(this.appendDummyInput());
      this.setPreviousStatement(true);
      this.setNextStatement(true);
      this.setStyle("procedure_blocks");
      this.contextMenu = false;
    },
    mutationToDom: function () {
      const container = Blockly.utils.xml.createElement("mutation");
      container.setAttribute("name", this.getFieldValue("NAME"));
      return container;
    },
    domToMutation: function (xmlElement) {
      const name = xmlElement.getAttribute("name");
      this.setFieldValue(name, "NAME");
    },
  };
  Blockly.Blocks["procedures_callnoreturn_2"] = Blockly.Blocks["procedures_callnoreturn_1"];

  BlocklyJs["procedures_callnoreturn_1"] = function (block: Blockly.Block) {
    const funcName = BlocklyJs.nameDB_.getName(
      block.getFieldValue("NAME"),
      Blockly.PROCEDURE_CATEGORY_NAME,
    );
    return `
    highlightBlock("${block.id}", true);
    if(--window.LoopTrap < 1) {
      if (scene && !scene.isDisposed) {
        scene.dispose();
      }
      setSuccess(false);
      setGameOver(true);
      return;
    };
    await ${funcName}();
    highlightBlock("${block.id}", false);
    \n`;
  };
  BlocklyJs["procedures_callnoreturn_2"] = BlocklyJs["procedures_callnoreturn_1"];

  BlocklyJs["procedures_callreturn"] = function (block: Blockly.Block) {
    const funcName = BlocklyJs.nameDB_.getName(
      block.getFieldValue("NAME"),
      Blockly.PROCEDURE_CATEGORY_NAME,
    );
    const args = [];
    const variables = block.getVars();
    for (let i = 0; i < variables.length; i++) {
      args[i] =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        BlocklyJs.valueToCode(block, `ARG${i}`, (Blockly as any).JavaScript.ORDER_NONE) || "null";
    }
    const code = `highlightBlock("${block.id}", undefined);unhighlight = true;
    if(--window.LoopTrap < 1) {
      if (scene && !scene.isDisposed) {
        scene.dispose();
      }
      setSuccess(false);
      setGameOver(true);
      return;
    };
    await ${funcName}(${args.join(", ")}) 
    unhighlight = undefined;`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [code, (Blockly as any).JavaScript.ORDER_FUNCTION_CALL];
  };
};
